// src/Components/AgentProtected.js
// SIMPLIFIED: Use existing UserContext instead of separate AgentContext

import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../Context/UnifiedAuthContext';

const AgentProtected = ({ children, requireAgent = true }) => {
  const { user, isAuthenticated, isAgent } = useAuth();
  const navigate = useNavigate();

  // If no user is logged in, redirect to agent login
  if (!isAuthenticated) {
    return (
      <div className="min-h-screen bg-[#fafafa] flex items-center justify-center">
        <div className="max-w-md w-full bg-white rounded-2xl shadow-lg border border-gray-100 p-8 text-center">
          <div className="w-16 h-16 bg-gradient-to-br from-[#10c9c0] to-[#0eb1a9] rounded-2xl flex items-center justify-center mx-auto mb-4">
            <i className="fas fa-building text-white text-2xl"></i>
          </div>
          <h2 className="text-2xl font-bold text-gray-900 mb-2">Agent Access Required</h2>
          <p className="text-gray-600 mb-6">Please log in to access this area.</p>
          <button
            onClick={() => navigate('/agent/login')}
            className="w-full py-3 px-4 rounded-xl font-medium text-white transition-all duration-200 bg-gradient-to-r from-[#10c9c0] to-[#0eb1a9] hover:from-[#0eb1a9] hover:to-[#10c9c0] hover:scale-[1.02] hover:shadow-lg hover:shadow-[#10c9c0]/25 active:scale-[0.98]"
          >
            Go to Agent Login
          </button>
        </div>
      </div>
    );
  }

  // If user is not an agent but agent access is required
  if (requireAgent && !isAgent) {
    return (
      <div className="min-h-screen bg-[#fafafa] flex items-center justify-center">
        <div className="max-w-md w-full bg-white rounded-2xl shadow-lg border border-gray-100 p-8 text-center">
          <div className="w-16 h-16 bg-gradient-to-br from-red-500 to-red-600 rounded-2xl flex items-center justify-center mx-auto mb-4">
            <i className="fas fa-exclamation-triangle text-white text-2xl"></i>
          </div>
          <h2 className="text-2xl font-bold text-gray-900 mb-2">Access Denied</h2>
          <p className="text-gray-600 mb-6">This area is restricted to agents only.</p>
          <button
            onClick={() => navigate('/')}
            className="w-full py-3 px-4 rounded-xl font-medium text-white transition-all duration-200 bg-gradient-to-r from-red-500 to-red-600 hover:from-red-600 hover:to-red-500 hover:scale-[1.02] hover:shadow-lg hover:shadow-red-500/25 active:scale-[0.98]"
          >
            Return to Home
          </button>
        </div>
      </div>
    );
  }

  // If all checks pass, render the protected content
  return children;
};

export default AgentProtected;